/**
 * @desc 预警
 */

import request from "@/utils/request";

/**
 * @desc 预警消息默认配置表
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getWarningDefaultList = (params) => request.post('/base/msgWarnConfig/page', params);

/**
 * @desc 预警开关（预警是否开启、公众号、APP、站内）
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const warningSwitch = (params) => request.post('/base/msgWarnConfig/switch', params);

/**
 * @desc 获取预警日志列表
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getWarningOperatorLog = (params) => request.post('/base/msgWarnLog/page', params);

/**
 * @desc 查询单个预警消息默认条件
 * @param id
 * @returns {AxiosPromise<any>}
 */
export const getWarningConfigDesc = (id) => request.get(`/base/msgWarnConfigTrigger/${id}`)

/**
 * @desc 修改单个预警消息默认条件
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const editWarningConfigDesc = (params) => request.put('/base/msgWarnConfigTrigger', params);

/**
 * @desc 查询是否开启轮询
 * @returns {AxiosPromise<any>}
 */
export const getPollingStatus = () => request.get('/base/msgWarnTenant/whether/enable');

/**
 * @desc 获取推送列表数据
 * @returns {AxiosPromise<any>}
 */
export const getPushList = () => request.get('/msgs/msg/v2/push');

/**
 * @desc 获取运营消息列表
 * @returns {AxiosPromise<any>}
 */
export const getOperationMessage = (params) => request.post('/msgs/msg/v2/list', params);

/**
 * @desc 将运营消息数据设置成已读
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const branchReadOperation = (params) => request.put('/msgs/msg/v2/mark', params);

/**
 * @desc 获取跟卖详情，id可多个
 * @param id
 * @returns {AxiosPromise<any>}
 */
export const querySellWithDetail = (ids) => request.get(`/msgs/msg/v2/offerMonitorWarnDetail?msgStr=${ids}`);

/**
 * @desc 获取除跟卖外的详情，id可多个
 * @param id
 * @returns {AxiosPromise<any>}
 */
// export const queryDetail = (ids) => request.get(`/msg/v2?msgIds=${ids}`);
export const queryDetail = (ids) => request.get(`/msgs/msg/v2/msgIds?msgIds=${ids}`);

/**
 *@desc 更新推送详情接口
 * @param ids
 * @returns {AxiosPromise<any>}
 */
export const updatePushStatus = (ids) => request.put(`/msgs/msg/v2/updatePush/${ids}`);
